module.exports = __webpack_public_path__ + "img/calendar-13.3b177592.svg";